import React, { useState, useCallback } from "react";
import HistoryDetail from "./HistoryDetail";
import { Box, IconButton, Button } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import CircleIcon from '@mui/icons-material/Circle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Alarms } from "../../../../actions/apiActions";
import { useDispatch } from "react-redux";
import { useSystemConfig, useSystemId } from "../../../../hooks/useReduxSelectors";
import { getAllDeviceAlarmsHistory } from "../../../../ducks/alarmsHistoryDuck";
import { status } from "../../../../../theme/muiTheme";

const headerSpanSx = {
  display: "inline-block",
  flex: 1,
  minWidth: 0,
  justifyContent: "center",
  alignSelf: "center",
  textAlign: "center",
  letterSpacing: "1px",
  fontSize: "18px",
};

const AlarmRow = ({ alarm }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const dispatch = useDispatch();
  const systemId = useSystemId();
  const config = useSystemConfig();

  const toggleExpand = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const triggerDate = new Date(alarm.triggerTimeStamp * 1000)
  const triggerTime = triggerDate.toLocaleTimeString() + " " + triggerDate.toLocaleDateString()
  let turnedOffTime = "";
  if (alarm.turnedOffTimeStamp) {
    const turnedOffDate = new Date(alarm.turnedOffTimeStamp * 1000)
    turnedOffTime = turnedOffDate.toLocaleTimeString() + " " + turnedOffDate.toLocaleDateString()
  }

  const clearAlarm = async (baseUrl, alarmToClear) => {
    const response = await Alarms.clearAlarm(baseUrl, alarmToClear);
    console.log("Alarm clear response:", response);
    if (response.status === 200) {
      console.log("Alarm cleared successfully");
      dispatch(getAllDeviceAlarmsHistory(systemId));
    } else {
      console.error("Failed to clear alarm:", response);
    }
  }

  const handleClearAlarmClick = (e) => {
    e.stopPropagation();
    const alarmToClear = {
      alarmId: alarm.alarmId,
      triggerTimeStamp: alarm.triggerTimeStamp,
      siteId: (config && config.CUSTOMER_ID) || "",
      edgeUnitId: (config && config.DEVICE_ID) || ""
    }
    const baseUrl = config.DATA_URL;
    clearAlarm(baseUrl, alarmToClear);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.light",
        borderRadius: 1,
        mb: 0.25,
        py: 0.5,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "stretch", cursor: "pointer" }} onClick={toggleExpand}>
        <Box component="span" sx={{ ...headerSpanSx, flex: 1.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "16px" }}>
          <span>{alarm.name ? alarm.name : alarm.alarmId}</span>
        </Box>

        <Box component="span" sx={headerSpanSx}>
          <span>
            {alarm.turnedOffTimeStamp === 0 && (
              <CircleIcon sx={{ color: status.error, fontSize: 18 }} />
            )}
            {alarm.turnedOffTimeStamp !== 0 && (
              <CircleIcon sx={{ color: status.success, fontSize: 18 }} />
            )}
          </span>
        </Box>

        <Box component="span" sx={headerSpanSx}>{alarm.brief}</Box>

        <Box component="span" sx={headerSpanSx}>
          {triggerTime}
        </Box>
        <Box component="span" sx={headerSpanSx}>
          {turnedOffTime}
        </Box>

        <Box component="span" sx={{ ...headerSpanSx, display: "flex", justifyContent: "center", flexDirection: "row" }}>
          {alarm.turnedOffTimeStamp === 0 ? (
            <IconButton variant="outlined" size="small" color="error" title="Clear Alarm" onClick={handleClearAlarmClick}>
              <CancelIcon />
            </IconButton>
          ) : <span></span>}
        </Box>
        <Box component="span" sx={headerSpanSx}>
          <IconButton size="small" sx={{ color: "inherit" }}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ display: isExpanded ? "block" : "none" }}>
        <HistoryDetail alarm={alarm} />
      </Box>
    </Box>
  );
};

export default AlarmRow;
